export default String.raw`
<div class="coupon-item coupon-item-js">
    <div class="coupon-info">
        <div class="coupon-code-display">
            <div class="coupon-icon-container coupon-icon-container-js">
                <div class="coupon-icon coupon-icon-js"></div>
            </div>
            <span class="coupon-type-name coupon-type-name-js"></span>
            <span class="code-prefix">{{ translations.WithCode }}</span>
            <span class="coupon-code coupon-code-js"></span>
            <button class="copy-code-btn copy-js" type="button" title="{{ translations.CopyCode }}" data-text="">
                <svg height="20" width="20" class="svgIcon">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#copy-{{settings.iconStyle}}"></use>
                </svg>
            </button>
        </div>
        <div class="coupon-validity coupon-validity-js"></div>
    </div>
    <a class="learn-more-btn learn-more-btn-js" href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=coupon-details" data-coupon-id="">
        {{ translations.FindOutMore }}
    </a>
</div>

`